export enum UserStatus {

  LoggedIn,
  Logging,
  NotLoggedIn

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/models/userStatus.ts